export default "__VITE_ASSET__ojLuYROo__"